const apiURL = process.env.REACT_APP_API_URL

async function client(
  endpoint,
  {data, token, headers: customHeaders, ...customConfig} = {},
) {
  let customToken =
    'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InJNQVhxLUM2ek1KVnFTMVFaRXpBNCJ9.eyJ1c2VyX3JvbGVzIjpbIkFkbWluIl0sIm5ldHdvcmtfaWQiOiJBbWl0LlJhbWFzaGFua2FyU2luZ2hAdGhyeXYuY29tIiwiZW1haWwiOiJBbWl0LlJhbWFzaGFua2FyU2luZ2hAdGhyeXYuY29tIiwiZmlyc3RuYW1lIjoiQW1pdCIsImxhc3RuYW1lIjoiUmFtYXNoYW5rYXIgU2luZ2giLCJpc3MiOiJodHRwczovL29vZS1kZXYudXMuYXV0aDAuY29tLyIsInN1YiI6Im9pZGN8T2t0YS1PT0VEZXZ8MDB1MW14bXJ2bGRXdjJhaGkwaDgiLCJhdWQiOlsiaHR0cHM6Ly9vb2UudGhyeXYuY29tLyIsImh0dHBzOi8vb29lLWRldi51cy5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNzQxNjEzNzk3LCJleHAiOjE3NDE3MDAxOTcsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhenAiOiJsWVZ2WVVFakpuSmF4dnlSek9aTFZBcXBjUUZOalNwRyJ9.R0bzHBxJaUGmI0_RQX7rw_ebSy1GgxzIfY6ruK0OBg0Jq-sfNCsKmdFPQuV00vi0I40NrdRkbMB6P3rKYmoc3MgybR-r-au8BP5DdxN9GdK_A13W3q-o4LvOHBwTgctOa5cdALDmV8Vo0FGBDtOTQUrkD963xlmQvbELVmFiY7SbOP7hrrmlQyejywclxRTg10B39cbPFwolteGBHgREyZ9au9VLsWIykcra9DB76rR_lWzB2SF0j8RqLZ5C1_5fnyW5U7K9lUCoJsDtbk-zEJ98U9HkeyooReKV-uaFjvYSza-To2ws4aUUX2p81ztMjko-feYWXy6jngky4AJb_A'
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    // headers: {
    //   Authorization: token ? `Bearer ${token}` : undefined,
    //   'Content-Type': data ? 'application/json' : undefined,
    //   ...customHeaders,
    //   'app-type': 'keap-client',
    // },
    headers: {
      Authorization: token ? `Bearer ${customToken}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
      'app-type': 'keap-client',
    },
    ...customConfig,
    users: {user_roles: ['Admin'], rep_id: 'amit.ramashankarsingh@thryv.com'},
  }

  return window.fetch(`${apiURL}/${endpoint}`, config).then(async response => {
    if (response.status === 401) {
      // TODO: logout()
      // refresh the page for them
      // window.location.assign(window.location)
      return Promise.reject({message: 'Please re-authenticate.'})
    }

    if (response.status === 404) {
      const errObjectString = await response.text()
      if (errObjectString === 'Not Found') {
        return Promise.reject({message: 'Not found', status: 404})
      }
      const errObject = JSON.parse(errObjectString)
      return Promise.reject({
        message: errObject?.message || 'Not found',
        status: 404,
      })
    }

    let ignoreInviteData
    try {
      ignoreInviteData = await response.clone().json()
    } catch {
      ignoreInviteData = await response.clone().text()
    }
    if (ignoreInviteData?.message === 'ignore invite error') {
      return
    }

    let data
    if (response.status === 201) {
      try {
        data = await response.json()
      } catch {
        data = undefined
      }
    }
    if (response.status !== 204 && response.status !== 201) {
      if (
        ['application/pdf', 'image/png'].includes(
          response.headers.get('Content-Type'),
        )
      ) {
        data = await response.blob()
      } else {
        data = await response.json()
      }
    }
    if (response.ok) {
      // eslint-disable-next-line no-prototype-builtins
      if (data && data.hasOwnProperty('sfToken')) {
        sessionStorage.setItem('sfToken', JSON.stringify(data.sfToken))
        delete data.sfToken
      }
      return data
    } else {
      return Promise.reject(data)
    }
  })
}

export {client}
